export default __webpack_public_path__ + "static/media/add.21df08fa.svg";